import React, { useEffect, useRef }   from 'react';
import useIsMounted                   from '@hooks/use-is-mounted';
import { Container, Divider, Group }  from '@mantine/core';
import { ClientOnly }                 from '@lib/ClientOnly';
import { getAddressText }             from '@utils/dxb-utils';
import { CSection }                   from '@core/components/common/CSection';
import { useRouter }                  from 'next/router';
import useAppData                     from '@hooks/use-app-data';
import { BookingCard }                from '@features/booking/components/BookingCard';
import { DetailsTitle }               from '@features/property-details/components/Title/DetailsTitle';
import { DetailsGallery }             from '@features/property-details/components/Gallery/DetailsGallery';
import { BasicDetailsTitle }          from '@features/property-details/components/BasicDetails/BasicDetailsTitle';
import { VideoSection }               from '@features/property-details/containers/sections/VideoSection/VideoSection';
import { DescriptionSection }         from '@features/property-details/containers/sections/DescriptionSection';
import { AmenitiesList }              from '@features/property-details/components/Amenities/AmenitiesList';
import { LocationDescriptionSection } from '@features/property-details/containers/sections/LocationDescriptionSection';
import { MapSection }                 from '@features/property-details/containers/sections/MapSection/MapSection';
import { ThingsToKnowSection }        from '@features/property-details/containers/sections/ThingsToKnowSection/ThingsToKnowSection';
import { usePropertyState }           from "@core/providers/PropertyStateProvider";

import useStyles                      from './PropertyDetailsLanding.styles';


export const PropertyDetailsLanding: React.FC = () => {

    const mountLock = useRef(true);
    const { classes } = useStyles();
    const isMounted = useIsMounted();

    const { propertyDetailsData } = usePropertyState();

    const { setLastPage } = useAppData();
    const router = useRouter();

    useEffect(() => {

        setLastPage(router.asPath)

        if(mountLock.current) {
            mountLock.current = false;
        }

    }, []);

    return isMounted && propertyDetailsData !== null && (
        <Container className={classes.propertyDetailsLanding}>

            <section key="HEADING">

                <DetailsTitle name={propertyDetailsData?.name}
                              address={getAddressText(propertyDetailsData?.location)}/>

                <BasicDetailsTitle details={propertyDetailsData?.details} settings={propertyDetailsData?.settings} />

            </section>

            <Divider/>

            <section key="GALLERY">
                {propertyDetailsData?.images?.length > 0 && <DetailsGallery />}
            </section>

            <Divider/>

            <section key="DETAILS">

                <Group spacing={0} position="apart" align="start" className={classes.propertyDetailsGrid}>

                    <div className={classes.propertyBookingDiv}>
                        <ClientOnly>
                            <BookingCard />
                        </ClientOnly>
                    </div>

                    <div className={classes.propertyDetailsDiv}>

                        {/*<Divider/>*/}

                        <DescriptionSection description={propertyDetailsData?.description}/>

                        <Divider/>

                        <CSection
                            heading="What this property offers"
                            content={
                                <AmenitiesList amenities={propertyDetailsData?.details?.amenities}/>
                            }
                        />

                        <Divider/>

                        <LocationDescriptionSection location={propertyDetailsData?.location}/>

                        <Divider/>

                        <VideoSection />

                    </div>

                </Group>

            </section>

            <Divider/>

            <section key="MAP">
                <MapSection />
            </section>

            <Divider/>

            <section>
                <ThingsToKnowSection/>
            </section>

        </Container>
    )

}

//TODO:: LOGOUT - BOOKING FLOW TESTS
